const doc = [({"en":({"js":({"admin":({"steps":({"element":({"the_element_was_duplicated":"The element was duplicated"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;